import { NgModule } from '@angular/core';
import { AngryBirdGameCoreModule } from './angry-bird-game-core';
import { ClassificationGameCoreModule } from './classification-game-core';
import { JumblesGameCoreModule } from './jumbles-game-core';
import { MarioGameCoreModule } from './mario-game-core';
import { MiniGameCoreModule } from './mini-game-core';
import { MonopolyTurnGameCoreModule } from './monopoly-turn-game-core';
import { MtcGameCoreModule } from './mtc-game-core';
import { OrderingGameCoreModule } from './ordering-game-core';
import { PackingGameCoreModule } from './packing-game-core';
import { PasswordGameCoreModule } from './password-game-core';
import { QuestionsGameCoreModule } from './questions-game-core';
import { SjtGameCoreModule } from './sjt-game-core';
import { WheelSpinGameCoreModule } from './wheel-spin-game-core';
import { SliderGameCoreModule } from './slider-game-core';
import { BubbleShooterGameCoreModule } from './bubble-shooter-game-core';
import { StickCricketGameCoreModule } from './stick-cricket-game-core';
import { FirePilotGameCoreModule } from './fire-pilot-game-core';
import { FruitNinjaGameCoreModule } from './fruit-ninja-game-core';
import { MazeGameCoreModule } from './maze-game-core';
import { PoolGameCoreModule } from './pool-game-core';
import { RacingGameCoreModule } from './racing-game-core';
import { PathFinderGameCoreModule } from './path-finder-game-core';
import { SpotOnGameCoreModule } from './spot-on-game-core';
import { SnakeLadderGameCoreModule } from './snake-ladder-game-core';
import { ParadropGameCoreModule } from './para-drop-game-core';
import { StraightShooterGameCoreModule } from './straight-shooter-game-core';
import { CrossWordsGameCoreModule } from './cross-words-game-core';
import { WordsPuzzleGameCoreModule } from './words-puzzle-game-core';

@NgModule({
  declarations: [],
  imports: [],
  exports: [
    ClassificationGameCoreModule,
    JumblesGameCoreModule,
    QuestionsGameCoreModule,
    SjtGameCoreModule,
    OrderingGameCoreModule,
    MtcGameCoreModule,
    MiniGameCoreModule,
    PasswordGameCoreModule,
    WheelSpinGameCoreModule,
    PackingGameCoreModule,
    MonopolyTurnGameCoreModule,
    MarioGameCoreModule,
    AngryBirdGameCoreModule,
    SliderGameCoreModule,
    BubbleShooterGameCoreModule,
    StickCricketGameCoreModule,
    FirePilotGameCoreModule,
    FruitNinjaGameCoreModule,
    MazeGameCoreModule,
    PoolGameCoreModule,
    RacingGameCoreModule,
    PathFinderGameCoreModule,
    SpotOnGameCoreModule,
    SnakeLadderGameCoreModule,
    ParadropGameCoreModule,
    StraightShooterGameCoreModule,
    CrossWordsGameCoreModule,
    WordsPuzzleGameCoreModule,
  ],
})
export class Level3GameCoreModule {}
